/**
 * Purchase Order Configuration
 * Configuration for Purchase Order form fields
 */

export interface PurchaseOrderFieldItem {
  fieldKey: string;
  fieldName: string;
  isActive: boolean; // Whether the configuration is active/enabled
  isRequired: boolean; // Whether the field is required or optional
  description?: string;
}

export const PURCHASE_ORDER_FIELD_OPTIONS = [
  {
    fieldKey: 'purchaseRequest',
    fieldName: 'purchase_order_config.fields.purchase_request',
    description: 'purchase_order_config.descriptions.purchase_request',
  },
  {
    fieldKey: 'series',
    fieldName: 'purchase_order_config.fields.series',
    description: 'purchase_order_config.descriptions.series',
  },
  {
    fieldKey: 'vendorCode',
    fieldName: 'purchase_order_config.fields.vendor',
    description: 'purchase_order_config.descriptions.vendor',
  },
  {
    fieldKey: 'description',
    fieldName: 'purchase_order_config.fields.description',
    description: 'purchase_order_config.descriptions.description',
  },
  {
    fieldKey: 'deliveryDate',
    fieldName: 'purchase_order_config.fields.delivery_date',
    description: 'purchase_order_config.descriptions.delivery_date',
  },
];

